import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./moreProducts.css";

export default function MoreProducts() {
  const navigate = useNavigate();
  const [productsData, setProductsData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedProductName, setSelectedProductName] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [responseModal, setResponseModal] = useState(null);

  useEffect(() => {
    fetch("backend/getGalleryData.php")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch product data");
        return res.json();
      })
      .then((data) => {
        setProductsData(data);
      })
      .catch((err) => {
        console.error("Error fetching JSON:", err);
      });
  }, []);

  const openModal = (productName) => {
    setSelectedProductName(productName);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setFormData({ name: "", phone: "" });
    setErrors({});
    setSelectedProductName("");
    setIsLoading(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) {
      newErrors.phone = "Contact number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Contact number must be exactly 10 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const body = new URLSearchParams({
        name: formData.name,
        phone: formData.phone,
        product: selectedProductName,
      });

      const response = await fetch("backend/productInquiry.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      const result = await response.json().catch(() => null);

      if (
        response.ok &&
        (result?.success || result?.status === "success" || !result?.error)
      ) {
        
        closeModal(); 
        setResponseModal({
          type: "success",
          message: "Your message has been sent successfully!",
        });
      } else {
        const msg =
          result?.message ||
          result?.error ||
          "Failed to send inquiry. Please try again.";
        closeModal(); 
        setResponseModal({ type: "error", message: msg });
      }
    } catch (error) {
      console.error("Error sending inquiry:", error);
      closeModal(); 
      setResponseModal({
        type: "error",
        message: "An error occurred while sending inquiry.",
      });
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className="more-products-page">
      <button className="close-btn" onClick={() => navigate("/product")}>
        &times;
      </button>

      <h2>More Products</h2>

      <div className="more-product-grid">
        {productsData.map((product, index) => (
          <div key={index} className="product-card">
            <div className="product-tilt-effect">
              <div className="more-product-image">
                <img
                  src={`images/moreProducts/${product.image}`}
                  alt={product.name}
                />
              </div>
            </div>

            <div className="more-product-info">
              <div className="more-product-category">{product.category}</div>
              <h2 className="more-product-title">{product.name}</h2>

              <div className="more-product-description">
                <p>{product.description}</p>
              </div>

              <div className="more-product-bottom">
                <button
                  className="more-product-button"
                  onClick={() => openModal(product.name)}
                >
                  <span className="more-button-text">Inquiry</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="inquiry-modal-overlay" onClick={closeModal}>
          <div className="inquiry-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModal}>
              ×
            </button>
            <h2>Product Inquiry</h2>
            <p className="inquiry-product-name">
              Product: <strong>{selectedProductName}</strong>
            </p>

            <form onSubmit={handleSubmit} className="inquiry-form">
              <input type="hidden" name="product" value={selectedProductName} />

              <div className="form-group">
                <label>Your Name:</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                {errors.name && <span className="error">{errors.name}</span>}
              </div>

              <div className="form-group">
                <label>Contact Number:</label>
                <input
                  name="phone"
                  type="number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                {errors.phone && <span className="error">{errors.phone}</span>}
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? "Sending..." : "Submit"}
              </button>

              <button
                type="button"
                formNoValidate
                className="call-btn"
                onClick={() => (window.location.href = "tel:9558567555")}
              >
                Call Us
              </button>
            </form>
          </div>
        </div>
      )}

      {responseModal && (
        <div
          className="response-modal-overlay"
          onClick={() => setResponseModal(null)}
        >
          <div
            className="response-modal"
            onClick={(e) => e.stopPropagation()}
          >
            {responseModal.type === "success" ? (
              <div className="icon success">✔</div>
            ) : (
              <div className="icon error">✖</div>
            )}
            <p>{responseModal.message}</p>
            <button
              className="ok-btn"
              onClick={() => {
                setResponseModal(null);
                if (responseModal.type === "success") {
                  closeModal();
                }
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
